<template>
    <div id="errorPage">
        <div class="box">
            <div class="text top">
                OOPS!
            </div>
            <div class="img">
                <img :src="errorSvg"/>
            </div>
            <div class="text bottom">
                我们出错了!
            </div>
            <router-link to="/" class="btn">
                再试一次!
            </router-link>
        </div>
    </div>
</template>

<script>
//静态资源导入
import errorSvg from '@/assets/svg/error.svg';

export default {
    name: "ErrorPage",
    data(){
        return {
            //静态资源声明S
            errorSvg:errorSvg,
            //静态资源声明E
        }
    },
    mounted(){
        setTimeout(() => {
            this.$root.loadingClose();
        }, 200);        
    }
}
</script>

<style lang="scsss" scoped src="@/assets/css/errorPage.scss"></style>